import { MuiButton } from './MuiButton';
import { MuiIconButton } from './MuiIconButton';
import { MuiInputAdornment } from './MuiInputAdornment';
import { MuiPaper } from './MuiPaper';
import { MuiTab } from './MuiTab';
import { MuiTabs } from './MuiTabs';
import { MuiTableCell } from './MuiTableCell';
import { MuiTableHead } from './MuiTableHead';
import { MuiInputBase } from './MuiInputBase';
import { MuiListItem } from './MuiListItem';
import { MuiCssBaseline } from './MuiCssBaseline';
import { MuiFilledInput } from './MuiFilledInput';
import { MuiTableRow } from './MuiTableRow';
import { MuiTableSortLabel } from './MuiTableSortLabel';
import { MuiAutocomplete } from './MuiAutocomplete';
import { MuiAlert } from './MuiAlert';

const overrides = {
  spacing: '55%',
  padding: '3%',
  minWidth: '1000px',
  MuiButton,
  MuiCssBaseline,
  MuiFilledInput,
  MuiIconButton,
  MuiAutocomplete,
  MuiTableSortLabel,
  MuiInputBase,
  MuiInputAdornment,
  MuiPaper,
  MuiTab,
  MuiTabs,
  MuiTableCell,
  MuiTableHead,
  MuiTableRow,
  MuiListItem,
  MuiAlert,
};

export { overrides };
